$(document).ready(function () {

    // Function to switch tabs
    function switchTabs(tab) {
        var targetPanel = $(tab.attr('href'));

        // Update the tab's aria-selected attribute and .show class
        $('.tab-list [aria-selected="true"]').attr('aria-selected', 'false').removeClass('show');
        tab.attr('aria-selected', 'true').addClass('show'); // Add .show class to the active tab

        // Hide all tab panels and show the target one
        $('.tab-panel').removeClass('show').attr('hidden', true);
        targetPanel.addClass('show').attr('hidden', false);
    }

    // Handle tab clicks
    $(document).on('click', '.tab-list [role="tab"]', function (e) {
        e.preventDefault();
        switchTabs($(this));
    });

    // Open tab based on URL hash
    function openTabFromHash() {
        var hash = window.location.hash;
        if (hash) {
            var tab = $('.tab-list a[href="' + hash + '"]');
            if (tab.length) {
                switchTabs(tab);
            }
        }
    }

    openTabFromHash();

    // Reopen tabs on hash change
    $(window).on('hashchange', function () {
        openTabFromHash();
    });

    // Accessibility: Allow 'Enter' or 'Space' to switch tabs
    $(document).on('keydown', '.tab-list [role="tab"]', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });
});
